import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useCoaching } from '../contexts/CoachingContext';

const IconBriefcase = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M20 7H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" />
  </svg>
);

const IconUsers = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a4 4 0 00-4-4h-1M9 20H4v-2a4 4 0 014-4h1m4 4v-2m0 2v2m-4-6a4 4 0 118 0 4 4 0 01-8 0z" />
  </svg>
);

const IconClipboard = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
  </svg>
);

const IconChart = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
  </svg>
);

const IconSearch = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
  </svg>
);

const IconCalendar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
);

const IconPlus = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
  </svg>
);

const IconClock = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6l4 2m6-2a10 10 0 11-20 0 10 10 0 0120 0z" />
  </svg>
);

const IconDocumentText = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
);

const IconUserGroup = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
  </svg>
);

const Coaching = () => {
  const { entrepreneurs, plans, sessions, stats, loading, fetchEntrepreneurs, fetchPlans, fetchSessions, fetchStats } = useCoaching();
  const [showNewEntrepreneur, setShowNewEntrepreneur] = useState(false);
  const [newEnt, setNewEnt] = useState({ company_name: '', entrepreneur_name: '', contact_email: '', contact_phone: '', sector: '' });
  const { createEntrepreneur } = useCoaching();

  useEffect(() => {
    fetchEntrepreneurs();
    fetchPlans();
    fetchSessions();
    fetchStats();
  }, [fetchEntrepreneurs, fetchPlans, fetchSessions, fetchStats]);

  const handleCreateEntrepreneur = async (e) => {
    e.preventDefault();
    try {
      await createEntrepreneur(newEnt);
      setNewEnt({ company_name: '', entrepreneur_name: '', contact_email: '', contact_phone: '', sector: '' });
      setShowNewEntrepreneur(false);
    } catch (err) {
      // error handled in context
    }
  };

  const recentSessions = [...sessions].sort((a, b) => new Date(b.session_date) - new Date(a.session_date)).slice(0, 5);

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-xl sm:text-2xl font-bold text-gray-900">Module Coaching</h1>
          <p className="text-gray-500 text-sm mt-1">Accompagnement, suivi et tableau de bord des entrepreneurs</p>
        </div>
        <button
          onClick={() => setShowNewEntrepreneur(true)}
          className="flex items-center justify-center space-x-2 bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary-600 transition-colors text-sm font-medium w-full sm:w-auto"
        >
          <IconPlus />
          <span>Nouvel entrepreneur</span>
        </button>
      </div>

      {/* Statistiques */}
      {stats && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4">
          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 rounded-lg bg-blue-50 flex items-center justify-center text-blue-600">
                <IconUsers />
              </div>
              <div>
                <p className="text-2xl font-bold text-gray-900">{stats.total_entrepreneurs}</p>
                <p className="text-xs text-gray-500">Entrepreneurs</p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 rounded-lg bg-green-50 flex items-center justify-center text-green-600">
                <IconClipboard />
              </div>
              <div>
                <p className="text-2xl font-bold text-gray-900">{stats.total_plans}</p>
                <p className="text-xs text-gray-500">Plans d'accompagnement</p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
                <IconBriefcase />
              </div>
              <div>
                <p className="text-2xl font-bold text-gray-900">{stats.total_sessions}</p>
                <p className="text-xs text-gray-500">Séances de coaching</p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 rounded-lg bg-purple-50 flex items-center justify-center text-purple-600">
                <IconChart />
              </div>
              <div>
                <p className="text-2xl font-bold text-gray-900">{stats.actions ? stats.actions.done : 0}</p>
                <p className="text-xs text-gray-500">Actions réalisées</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Navigation modules */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        <Link to="/coaching/diagnostic" className="bg-white rounded-lg border border-gray-200 p-5 hover:shadow-md hover:border-amber-400/60 transition-all group">
          <div className="w-10 h-10 rounded-lg bg-amber-50 text-amber-600 flex items-center justify-center mb-3 group-hover:bg-amber-100">
            <IconSearch />
          </div>
          <h3 className="font-semibold text-gray-900 mb-1">Diagnostic</h3>
          <p className="text-sm text-gray-500">Évaluation complète sur 9 axes : Marché, RH, Finance, Gouvernance, Durabilité… Matrice SWOT.</p>
          <div className="mt-3 text-xs font-medium text-amber-600">9 axes · Forces, Faiblesses, Opp., Menaces</div>
        </Link>

        <Link to="/coaching/plan" className="bg-white rounded-lg border border-gray-200 p-5 hover:shadow-md hover:border-primary/40 transition-all group">
          <div className="w-10 h-10 rounded-lg bg-green-50 text-green-600 flex items-center justify-center mb-3 group-hover:bg-green-100">
            <IconClipboard />
          </div>
          <h3 className="font-semibold text-gray-900 mb-1">Plan d'accompagnement</h3>
          <p className="text-sm text-gray-500">Construire et suivre les plans d'action par axe : Marché, Production, RH, Financement…</p>
          <div className="mt-3 text-xs font-medium text-primary">{plans.length} plan{plans.length !== 1 ? 's' : ''} actif{plans.length !== 1 ? 's' : ''}</div>
        </Link>

        <Link to="/coaching/minutes" className="bg-white rounded-lg border border-gray-200 p-5 hover:shadow-md hover:border-primary/40 transition-all group">
          <div className="w-10 h-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center mb-3 group-hover:bg-primary/20">
            <IconBriefcase />
          </div>
          <h3 className="font-semibold text-gray-900 mb-1">Procès Verbal de coaching</h3>
          <p className="text-sm text-gray-500">Enregistrer chaque séance, actions mises en œuvre, bilan et prochaines étapes.</p>
          <div className="mt-3 text-xs font-medium text-primary">{sessions.length} séance{sessions.length !== 1 ? 's' : ''} enregistrée{sessions.length !== 1 ? 's' : ''}</div>
        </Link>

        <Link to="/coaching/dashboard" className="bg-white rounded-lg border border-gray-200 p-5 hover:shadow-md hover:border-primary/40 transition-all group">
          <div className="w-10 h-10 rounded-lg bg-purple-50 text-purple-600 flex items-center justify-center mb-3 group-hover:bg-purple-100">
            <IconChart />
          </div>
          <h3 className="font-semibold text-gray-900 mb-1">Tableau de bord</h3>
          <p className="text-sm text-gray-500">Indicateurs clés, suivi prévu/réalisé, graphiques et consolidation incubateur.</p>
          <div className="mt-3 text-xs font-medium text-primary">Indicateurs par entrepreneur</div>
        </Link>
      </div>

      {/* Séparateur section RH */}
      <div className="border-t border-gray-100 pt-2">
        <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">Ressources Humaines</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
          {/* PTBA */}
          <div className="bg-white rounded-lg border border-dashed border-gray-300 p-5 opacity-60">
            <div className="w-10 h-10 rounded-lg bg-indigo-50 text-indigo-500 flex items-center justify-center mb-3">
              <IconDocumentText />
            </div>
            <h3 className="font-semibold text-gray-700 mb-1">PTBA</h3>
            <p className="text-sm text-gray-400">Plan de Travail et Budget Annuel — Prochainement disponible.</p>
            <div className="mt-3 text-xs font-medium text-indigo-400">À venir</div>
          </div>

          {/* Fiche Temps — outil de la plateforme principale (version MOOC retirée) */}
          <a
            href="https://app.innovactive360.cloud/coaching/fiche-temps"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white rounded-lg border border-gray-200 p-5 hover:shadow-md hover:border-teal-400/60 transition-all group"
          >
            <div className="w-10 h-10 rounded-lg bg-teal-50 text-teal-600 flex items-center justify-center mb-3 group-hover:bg-teal-100">
              <IconClock />
            </div>
            <h3 className="font-semibold text-gray-900 mb-1">Fiche Temps</h3>
            <p className="text-sm text-gray-500">
              Saisie mensuelle des heures par programme, validation et tableau de bord.
            </p>
            <div className="mt-3 text-xs font-medium text-teal-600">Ouvrir sur la plateforme</div>
          </a>

          {/* Equipe */}
          <div className="bg-white rounded-lg border border-dashed border-gray-300 p-5 opacity-60">
            <div className="w-10 h-10 rounded-lg bg-orange-50 text-orange-500 flex items-center justify-center mb-3">
              <IconUserGroup />
            </div>
            <h3 className="font-semibold text-gray-700 mb-1">Equipe</h3>
            <p className="text-sm text-gray-400">Gestion des membres de l'équipe et des ressources humaines — Prochainement disponible.</p>
            <div className="mt-3 text-xs font-medium text-orange-400">À venir</div>
          </div>
        </div>
      </div>

      {/* Liste entrepreneurs + Séances récentes */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Entrepreneurs */}
        <div className="bg-white rounded-lg border border-gray-200">
          <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
            <h2 className="font-semibold text-gray-900">Entrepreneurs accompagnés</h2>
            <span className="text-xs text-gray-500">{entrepreneurs.length} au total</span>
          </div>
          {loading ? (
            <div className="p-5 space-y-3">
              {[1, 2, 3].map(i => (
                <div key={i} className="animate-pulse h-14 bg-gray-100 rounded-lg" />
              ))}
            </div>
          ) : entrepreneurs.length === 0 ? (
            <div className="p-8 text-center text-gray-400">
              <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-3">
                <IconUsers />
              </div>
              <p className="text-sm">Aucun entrepreneur enregistré</p>
              <button
                onClick={() => setShowNewEntrepreneur(true)}
                className="mt-3 text-primary text-sm font-medium hover:underline"
              >
                Ajouter le premier entrepreneur
              </button>
            </div>
          ) : (
            <ul className="divide-y divide-gray-50">
              {entrepreneurs.map(ent => (
                <li key={ent.id} className="px-5 py-3 flex items-center justify-between hover:bg-gray-50">
                  <div>
                    <p className="font-medium text-gray-900 text-sm">{ent.company_name}</p>
                    <p className="text-xs text-gray-500">{ent.entrepreneur_name}{ent.sector ? ` · ${ent.sector}` : ''}</p>
                  </div>
                  <div className="flex space-x-2">
                    <Link
                      to={`/coaching/diagnostic?entrepreneur=${ent.id}`}
                      className="text-xs px-3 py-1 rounded bg-amber-50 text-amber-700 hover:bg-amber-100 font-medium"
                    >
                      Diag
                    </Link>
                    <Link
                      to={`/coaching/plan?entrepreneur=${ent.id}`}
                      className="text-xs px-3 py-1 rounded bg-green-50 text-green-700 hover:bg-green-100 font-medium"
                    >
                      Plan
                    </Link>
                    <Link
                      to={`/coaching/dashboard?entrepreneur=${ent.id}`}
                      className="text-xs px-3 py-1 rounded bg-purple-50 text-purple-700 hover:bg-purple-100 font-medium"
                    >
                      TdB
                    </Link>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Séances récentes */}
        <div className="bg-white rounded-lg border border-gray-200">
          <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
            <h2 className="font-semibold text-gray-900">Séances récentes</h2>
            <Link to="/coaching/minutes" className="text-xs text-primary font-medium hover:underline">Voir tout</Link>
          </div>
          {recentSessions.length === 0 ? (
            <div className="p-8 text-center text-gray-400">
              <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-3">
                <IconCalendar />
              </div>
              <p className="text-sm">Aucune séance enregistrée</p>
              <Link to="/coaching/minutes" className="mt-3 inline-block text-primary text-sm font-medium hover:underline">
                Créer une séance
              </Link>
            </div>
          ) : (
            <ul className="divide-y divide-gray-50">
              {recentSessions.map(s => (
                <li key={s.id} className="px-5 py-3">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="font-medium text-gray-900 text-sm">
                        {s.coaching_entrepreneurs?.company_name || 'Entrepreneur'}
                      </p>
                      <p className="text-xs text-gray-500 flex items-center space-x-1 mt-0.5">
                        <IconCalendar />
                        <span>{new Date(s.session_date).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
                      </p>
                    </div>
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                      s.status === 'validated' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'
                    }`}>
                      {s.status === 'validated' ? 'Validé' : 'Brouillon'}
                    </span>
                  </div>
                  {s.next_session_date && (
                    <p className="text-xs text-gray-400 mt-1">
                      Prochain coaching : {new Date(s.next_session_date).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
                    </p>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {/* Modal nouveau entrepreneur */}
      {showNewEntrepreneur && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md">
            <div className="px-6 py-4 border-b border-gray-100">
              <h3 className="font-semibold text-gray-900">Nouvel entrepreneur</h3>
            </div>
            <form onSubmit={handleCreateEntrepreneur} className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Nom de l'entreprise *</label>
                <input
                  type="text"
                  required
                  value={newEnt.company_name}
                  onChange={e => setNewEnt(p => ({ ...p, company_name: e.target.value }))}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
                  placeholder="Ex : Innovatech SARL"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Nom de l'entrepreneur *</label>
                <input
                  type="text"
                  required
                  value={newEnt.entrepreneur_name}
                  onChange={e => setNewEnt(p => ({ ...p, entrepreneur_name: e.target.value }))}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
                  placeholder="Ex : Jean Dupont"
                />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                  <input
                    type="email"
                    value={newEnt.contact_email}
                    onChange={e => setNewEnt(p => ({ ...p, contact_email: e.target.value }))}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
                    placeholder="contact@..."
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Téléphone</label>
                  <input
                    type="text"
                    value={newEnt.contact_phone}
                    onChange={e => setNewEnt(p => ({ ...p, contact_phone: e.target.value }))}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
                    placeholder="+33..."
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Secteur d'activité</label>
                <input
                  type="text"
                  value={newEnt.sector}
                  onChange={e => setNewEnt(p => ({ ...p, sector: e.target.value }))}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
                  placeholder="Ex : Agriculture, Tech, Commerce..."
                />
              </div>
              <div className="flex justify-end space-x-3 pt-2">
                <button
                  type="button"
                  onClick={() => setShowNewEntrepreneur(false)}
                  className="px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 text-sm bg-primary text-white rounded-lg hover:bg-primary-600 font-medium"
                >
                  Créer
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Coaching;
